"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const react_cookie_1 = require("react-cookie");
const Popover_1 = __importDefault(require("@mui/material/Popover"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const AppBar_1 = __importDefault(require("@mui/material/AppBar"));
const Toolbar_1 = __importDefault(require("@mui/material/Toolbar"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const CssBaseline_1 = __importDefault(require("@mui/material/CssBaseline"));
const Container_1 = __importDefault(require("@mui/material/Container"));
const KeyboardArrowUp_1 = __importDefault(require("@mui/icons-material/KeyboardArrowUp"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const Stack_1 = __importDefault(require("@mui/material/Stack"));
const material_1 = require("@mui/material");
const ClickAwayListener_1 = __importDefault(require("@mui/material/ClickAwayListener"));
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const better_react_mathjax_1 = require("better-react-mathjax");
const services_1 = require("../services");
const CalcDialog_1 = __importDefault(require("./CalcDialog"));
const RefDialog_1 = __importDefault(require("./RefDialog"));
const DetailPopup_1 = __importDefault(require("./DetailPopup"));
const Review_1 = __importDefault(require("./Review"));
const ReviewPage_1 = __importDefault(require("./ReviewPage"));
const Question_1 = __importDefault(require("./Question"));
const Confirmation_1 = __importDefault(require("./Confirmation"));
const shared_1 = require("../shared");
const Processing_1 = __importDefault(require("../components/Processing"));
const react_countdown_1 = __importDefault(require("react-countdown"));
function Quiz() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
    const { quizId } = (0, react_router_dom_1.useParams)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const location = (0, react_router_dom_1.useLocation)();
    // Get extraTime from the query string
    const queryParams = new URLSearchParams(location.search);
    const extraTime = parseInt(queryParams.get("extraTime"), 10);
    const cookies = new react_cookie_1.Cookies();
    const domain = (0, shared_1.getDomain)();
    const quizType = cookies.get('quiz_type') || " ";
    const [initLoad, setInitLoad] = (0, react_1.useState)(true);
    const [forReview, setForReview] = (0, react_1.useState)([]);
    const [answers, setAnswers] = (0, react_1.useState)([]);
    const [diagnostics, setDiagnostics] = (0, react_1.useState)([]);
    const [currentDiagnostic, setCurrentDiagnostic] = (0, react_1.useState)(0);
    const [addAnswers, { isLoading: isUpdating }] = (0, services_1.useAddAnswerMutation)();
    const [addOverTime] = (0, services_1.useOverTimeMutation)();
    const [updateOnPause] = (0, services_1.useUpdateOnPauseMutation)();
    const [complete, { isLoading: isCompleting }] = (0, services_1.useCompleteMutation)();
    const [nextDiagnostic, setnextDiagnostic] = (0, react_1.useState)(0);
    const currentDiag = (diagnostics === null || diagnostics === void 0 ? void 0 : diagnostics.length) ? (nextDiagnostic == 0 ? parseInt(diagnostics[currentDiagnostic]) : nextDiagnostic) : 0;
    let { data: quizDetail, isLoading, refetch, } = (0, services_1.useQuizDetailQuery)(quizId, {
        refetchOnFocus: true,
    });
    const { data: diagDetail } = (0, services_1.useDiagnosticDetailQuery)(currentDiag, {
        skip: quizDetail === null || quizDetail === void 0 ? void 0 : quizDetail.complete,
    });
    const [currentQuestion, setCurrentQuestion] = (0, react_1.useState)(0);
    const questions = (_a = quizDetail === null || quizDetail === void 0 ? void 0 : quizDetail.questions[currentDiag]) === null || _a === void 0 ? void 0 : _a.questions;
    const questionId = currentDiag > 0 && (questions === null || questions === void 0 ? void 0 : questions.length) ? questions[currentQuestion] : null;
    const { data: question, isLoading: isQuestionLoading } = (0, services_1.useQuestionQuery)(questionId, {
        skip: !questionId,
    });
    const [skip, setSkip] = React.useState(true);
    let { data: nextDiag, isLoading: isNextDiagLoading, refetch: refetchNextDiag, isFetching, } = (0, services_1.useGenerateNextDiagIdQuery)(quizId, {
        skip: skip,
        refetchOnFocus: true,
    });
    const [completed, setCompleted] = (0, react_1.useState)(false);
    const [review, setReview] = (0, react_1.useState)(false);
    const [reviewPage, setReviewPage] = (0, react_1.useState)(false);
    const [negativeTime, setNegativeTime] = (0, react_1.useState)(false);
    const [negTimer, setNegTimer] = (0, react_1.useState)(0);
    const negTimerRef = (0, react_1.useRef)(null);
    const [saveExitDialogOpen, setSaveExitDialogOpen] = React.useState(false);
    const [showCalculator, setShowCalculator] = (0, react_1.useState)(false);
    const [showReference, setShowReference] = (0, react_1.useState)(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [reviewAnchorEl, setReviewAnchorEl] = React.useState(null);
    const [timer, setTimer] = (0, react_1.useState)(0); // Individual question timer
    const timerRef = (0, react_1.useRef)(null);
    const [user, setUser] = (0, react_1.useState)(null);
    const [showTimer, setShowTimer] = (0, react_1.useState)(true);
    const [qStartTime, setQStartTime] = (0, react_1.useState)(0);
    const [qNegStartTime, setQNegStartTime] = (0, react_1.useState)(0);
    const [contentApi, setContentApi] = React.useState(null);
    const [endModule, setEndModule] = (0, react_1.useState)(true);
    const [firstLoad, setFirstLoad] = (0, react_1.useState)(false);
    const [endofModule, setEndofModule] = (0, react_1.useState)(false);
    const popupRef = (0, react_1.useRef)(null);
    const [testTypeList, setTestTypeList] = React.useState([]);
    const startDate = React.useRef(Date.now());
    const negstartDate = React.useRef(null);
    const defaultRenderer = ({ hours, minutes, seconds, completed }) => {
        let mins = minutes, sec = seconds;
        if (minutes == 0 && seconds == 0 && timer != 0) {
            if (!negativeTime) {
                setNegativeTime(true);
                negstartDate.current = Date.now();
            }
        }
        if (minutes == 0) {
            mins = "00";
        }
        if (seconds.toString().length == 1) {
            sec = "0" + seconds;
        }
        return ((0, jsx_runtime_1.jsxs)("span", { children: [mins, ":", sec] }));
    };
    const negdefaultRenderer = ({ hours, minutes, seconds, completed }) => {
        let mins = minutes, sec = seconds;
        if (minutes == 0) {
            mins = "00";
        }
        if (seconds.toString().length == 1) {
            sec = "0" + seconds;
        }
        return ((0, jsx_runtime_1.jsxs)("span", { children: [mins, ":", sec] }));
    };
    (0, react_1.useEffect)(() => {
        initGet();
        if (initLoad && quizType === "resume") {
            refetch();
        }
    }, []);
    const initGet = async () => {
        const user = await (0, shared_1.getCurrentUser)();
        setUser(user || null);
        setContentApi(await (0, shared_1.getCmsURL)());
        setTestTypeList(await (0, shared_1.getStrapiData)(`test-types?&sort=displayOrder:asc`));
    };
    (0, react_1.useEffect)(() => {
        if (!isLoading && initLoad && quizType === "resume") {
            let ans = quizDetail.answers;
            //nextDiag = undefined;
            if (ans) {
                const result = ans.map(item => (Object.assign(Object.assign({}, item), { questionId: item.questionId.toString() })));
                //setTimer(quizDetail?.pauseTime)
                setAnswers(result);
                if ((quizDetail === null || quizDetail === void 0 ? void 0 : quizDetail.pauseTime) < 0) {
                    setNegativeTime(true);
                }
                setInitLoad(false);
                setCurrentQuestion(quizDetail === null || quizDetail === void 0 ? void 0 : quizDetail.pauseQuestion);
                if (quizDetail === null || quizDetail === void 0 ? void 0 : quizDetail.reviewMarked) {
                    var array = quizDetail === null || quizDetail === void 0 ? void 0 : quizDetail.reviewMarked.split(",").map(Number);
                    setForReview(array);
                }
            }
        }
    }, [isLoading]);
    const renderImage = (data) => {
        const imageRegex = /!\[([^\]]*?)\]\(([^)]*?)\)/g;
        const newData = data === null || data === void 0 ? void 0 : data.replace(imageRegex, (match, altText, imageUrl) => {
            return `<img style='height: 90%; width: 90%;' alt='${altText}' src='${contentApi}${imageUrl}' />`;
        });
        return newData;
    };
    const onClose = () => {
        setReviewAnchorEl(null);
    };
    (0, react_1.useEffect)(() => {
        if (quizDetail === null || quizDetail === void 0 ? void 0 : quizDetail.questions) {
            setDiagnostics(Object.keys(quizDetail.questions));
            setCurrentDiagnostic(0);
            if (quizType === "resume") {
                let score = quizDetail.score;
                const length = Object.keys(score).length;
                setCurrentDiagnostic(length - 1);
            }
            if (!skip) {
                const newDiagId = Object.keys(quizDetail === null || quizDetail === void 0 ? void 0 : quizDetail.overallScore).find((key) => (quizDetail === null || quizDetail === void 0 ? void 0 : quizDetail.overallScore[key]) == 0);
                setnextDiagnostic(parseInt(newDiagId));
                setDiagnostics(Object.keys(quizDetail.questions));
                setCurrentDiagnostic(currentDiagnostic + 1);
                setCurrentQuestion(0);
                setFirstLoad(false);
                setEndofModule(false);
            }
        }
    }, [quizDetail]);
    (0, react_1.useEffect)(() => {
        if (nextDiag != undefined) {
            if (Object.keys(nextDiag === null || nextDiag === void 0 ? void 0 : nextDiag.questions).length > Object.keys(quizDetail === null || quizDetail === void 0 ? void 0 : quizDetail.questions).length) {
                refetch();
            }
            else {
                refetchNextDiag();
                // setEndModule(false);
                // setOpenConfirm(true);
                // setCompleted(true);
            }
            if (nextDiag === null || nextDiag === void 0 ? void 0 : nextDiag.complete) {
                setEndModule(false);
                setOpenConfirm(true);
                setCompleted(true);
                refetch();
            }
        }
    }, [nextDiag]);
    (0, react_1.useEffect)(() => {
        if (nextDiag != undefined && firstLoad) {
            if (Object.keys(nextDiag === null || nextDiag === void 0 ? void 0 : nextDiag.questions).length === Object.keys(nextDiag === null || nextDiag === void 0 ? void 0 : nextDiag.questions).length) {
                refetchNextDiag().then(() => {
                    setFirstLoad(true);
                    refetch();
                });
            }
        }
    }, [firstLoad]);
    (0, react_1.useEffect)(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                onClose();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);
    (0, react_1.useEffect)(() => {
        var _a, _b, _c;
        let time;
        if (quizType === "resume" && (quizDetail === null || quizDetail === void 0 ? void 0 : quizDetail.pauseTime) > 0) {
            time = quizDetail === null || quizDetail === void 0 ? void 0 : quizDetail.pauseTime;
        }
        else if (quizType !== "resume") {
            time = (_c = (_b = (_a = diagDetail === null || diagDetail === void 0 ? void 0 : diagDetail.diagnostic) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.attributes) === null || _c === void 0 ? void 0 : _c.Duration;
        }
        // Start the timer for the current question when it changes
        if (time) {
            let adjustedTime = time;
            if (extraTime === 50) {
                adjustedTime = time + Math.floor(time / 2); // Add 50% extra time
            }
            else if (extraTime === 100) {
                adjustedTime = time * 2; // Double the time
            }
            else if (extraTime === 200) {
                adjustedTime = time * 4;
            }
            setTimer(adjustedTime);
            setQStartTime(adjustedTime);
            if (startDate.current) {
                startDate.current = Date.now();
            }
            // timerRef.current = setInterval(() => {
            // 	setTimer((prevTimer) => {
            // 		if (prevTimer === 0) {
            // 			clearInterval(timerRef.current!);
            // 			setNegativeTime(true);
            // 			// handleAnswerButtonClick(''); // Automatically move to the next question
            // 			return 0;
            // 		}
            // 		return prevTimer - 1;
            // 	});
            // }, 1000);
        }
        // return () => {
        // 	// Clear the timer when the component unmounts or the question changes
        // 	if (timerRef.current) {
        // 		clearInterval(timerRef.current);
        // 	}
        // };
    }, [diagDetail]);
    (0, react_1.useEffect)(() => {
        let time = 0;
        if (negativeTime) {
            if (quizType === "resume" && (quizDetail === null || quizDetail === void 0 ? void 0 : quizDetail.pauseTime) < 0) {
                time = (quizDetail === null || quizDetail === void 0 ? void 0 : quizDetail.pauseTime) * -1;
            }
            // setNegTimer(time);
            // setQNegStartTime(time);
            // negTimerRef.current = setInterval(() => {
            // 	setNegTimer((prevTimer) => {
            // 		return prevTimer + 1;
            // 	});
            // }, 1000);
            // return () => {
            // 	// Clear the timer when the component unmounts or the question changes
            // 	if (negTimerRef.current) {
            // 		clearInterval(negTimerRef.current);
            // 	}
            // };
        }
    }, [negativeTime]);
    (0, react_1.useEffect)(() => {
        setReview(forReview.indexOf(currentQuestion) !== -1);
    }, [currentQuestion]);
    (0, react_1.useEffect)(() => {
        updateTimeSpent();
    }, [reviewPage]);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleReviewClick = (event) => {
        setReviewAnchorEl(event.currentTarget);
    };
    const handleClickAway = () => {
        setAnchorEl(null);
        // setReviewAnchorEl(null);
    };
    const handleMarkReview = () => {
        setReview(!review);
        setForReview((prevForReview) => {
            if (prevForReview.includes(currentQuestion)) {
                return prevForReview.filter((x) => x !== currentQuestion);
            }
            else {
                return [...prevForReview, currentQuestion];
            }
        });
    };
    const handleSelectedAnswer = (value) => {
        var _a, _b;
        const currentAnswer = answers.filter((x) => x.questionId === question.id);
        const filteredAnswers = answers.filter((x) => x.questionId !== question.id);
        if ((question === null || question === void 0 ? void 0 : question.type) === 'choice') {
            setAnswers([...filteredAnswers, { questionId: question.id, selectedChoice: value, answer: null, timeSpent: ((_a = currentAnswer[0]) === null || _a === void 0 ? void 0 : _a.timeSpent) || 0 }]);
        }
        else {
            if (value != null)
                setAnswers([...filteredAnswers, { questionId: question.id, selectedChoice: null, answer: value, timeSpent: ((_b = currentAnswer[0]) === null || _b === void 0 ? void 0 : _b.timeSpent) || 0 }]);
        }
    };
    const getTimeSpent = (previousTime) => {
        const timeUsed = qStartTime - timer;
        const timeSpent = (previousTime || 0) > 0 ? previousTime + timeUsed : timeUsed;
        setQStartTime(timer);
        return timeSpent;
    };
    const getNegativeTimeSpent = (previousTime) => {
        const timeUsed = negTimer - qNegStartTime;
        const timeSpent = (previousTime || 0) > 0 ? previousTime + timeUsed : timeUsed;
        setQNegStartTime(negTimer);
        return timeSpent;
    };
    const updateTimeSpent = () => {
        answers.map((i) => {
            if (i.questionId === question.id) {
                if (negativeTime) {
                    i.timeSpent = getNegativeTimeSpent(i.timeSpent);
                }
                else {
                    i.timeSpent = getTimeSpent(i.timeSpent);
                }
            }
        });
    };
    const handleNext = (isNext) => {
        setReviewAnchorEl(null);
        updateTimeSpent();
        setCurrentQuestion(!isNext ? currentQuestion - 1 : currentQuestion + 1);
    };
    const setReviewQuestion = (qId) => {
        const currentAnswer = answers.filter((x) => x.questionId === question.id);
        if (currentAnswer.length <= 0) {
            handleSelectedAnswer(null);
        }
        updateTimeSpent();
        setCurrentQuestion(qId);
    };
    // useEffect(() => {
    // 	if (isQuestionLoading || isLoading) return;
    // 	if (!questions || questions.length <= 0) {
    // 		handleComplete();
    // 	}
    // }, [currentDiagnostic]);
    const handleComplete = async () => {
        setReviewAnchorEl(null);
        setOpenConfirm(true);
    };
    const handleReview = async () => {
        setReviewPage(true);
    };
    const handleCompleteAfterConfirm = async () => {
        updateTimeSpent();
        if (diagnostics && diagnostics.length - 1 > currentDiagnostic) {
            setCurrentDiagnostic(currentDiagnostic + 1);
            setCurrentQuestion(0);
            return;
        }
        setCompleted(true);
        await addAnswers({ quizId, complete: true, mode: "default", answer: answers }).unwrap();
        // await complete({ quizId }).unwrap();
    };
    const [openConfirm, setOpenConfirm] = React.useState(false);
    const confirmAnswer = async (answer) => {
        setOpenConfirm(false);
        if (answer) {
            //handleCompleteAfterConfirm();
            if (quizType === "resume") {
                await updateOnPause({ quizId, body: { onPause: false, pauseTime: 0, pauseQuestion: 0, reviewMarked: "" } }).unwrap();
                cookies.remove('quiz_type', domain);
            }
            setTimer(0);
            setForReview([]);
            setEndofModule(true);
            setReviewPage(false);
            setReview(false);
            setNegativeTime(false);
            cookies.remove('quiz_type', domain);
            if (timerRef.current) {
                clearInterval(timerRef.current);
            }
            if (negTimerRef.current) {
                clearInterval(negTimerRef.current);
            }
            if (negativeTime) {
                await addOverTime({ quizId, body: { diagId: currentDiag, timeSpent: negTimer } }).unwrap();
            }
            let mode = quizType;
            if (mode == " ") {
                mode = "default";
            }
            await addAnswers({ quizId, complete: false, mode: mode, answer: answers })
                .unwrap()
                .then((value) => {
                setSkip(false);
                if (nextDiag != undefined)
                    setFirstLoad(true);
                if (!questionId) {
                    setEndModule(false);
                    setOpenConfirm(true);
                    setCompleted(true);
                    complete({ quizId }).unwrap();
                }
            });
        }
    };
    const saveExithandleClose = () => {
        setSaveExitDialogOpen(false);
    };
    const saveExithandleSave = async () => {
        var _a;
        let mode = quizType;
        if (mode == " ") {
            mode = "default";
        }
        await addAnswers({ quizId, complete: false, mode: mode, answer: answers }).unwrap();
        let pauseTime = timer;
        if (negativeTime) {
            pauseTime = negTimer * -1;
        }
        if (negTimerRef.current) {
            clearInterval(negTimerRef.current);
        }
        if (timerRef.current) {
            clearInterval(timerRef.current);
        }
        await updateOnPause({ quizId, body: { onPause: true, pauseTime: pauseTime, pauseQuestion: currentQuestion, reviewMarked: forReview.toString() } }).unwrap();
        setSaveExitDialogOpen(false);
        cookies.remove('quiz_type', domain);
        setInitLoad(true);
        refetch();
        setNegativeTime(false);
        navigate(`/diagnostics/${(testTypeList === null || testTypeList === void 0 ? void 0 : testTypeList.length) > 0 ? (_a = testTypeList[0]) === null || _a === void 0 ? void 0 : _a.id : 0}`);
    };
    if (isQuestionLoading || !question)
        return (0, jsx_runtime_1.jsx)(Processing_1.default, { isProceesing: true });
    if (isNextDiagLoading || isFetching)
        return (0, jsx_runtime_1.jsx)(Processing_1.default, { isProceesing: true });
    if (isUpdating)
        return (0, jsx_runtime_1.jsx)(Processing_1.default, { isProceesing: true });
    if (completed)
        return ((0, jsx_runtime_1.jsx)(Container_1.default, { children: (0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ direction: 'column', justifyContent: 'center', alignItems: 'center', spacing: 2, sx: { p: 4 } }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ sx: { fontSize: '2vmax' } }, { children: "You're All Finished" })), (0, jsx_runtime_1.jsx)("img", { src: '/assets/complete-latest.png', style: { width: '60%' }, alt: 'complete' }), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ color: 'primary', variant: 'contained', sx: { borderRadius: 20, margin: '0px auto' }, onClick: () => navigate(`/reports/${user === null || user === void 0 ? void 0 : user.id}`) }, { children: "Click here to view your test scores" }))] })) }));
    return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)(CssBaseline_1.default, {}), showCalculator && (0, jsx_runtime_1.jsx)(CalcDialog_1.default, { onClose: () => setShowCalculator(false) }), showReference && (0, jsx_runtime_1.jsx)(RefDialog_1.default, { description: (_d = (_c = (_b = diagDetail === null || diagDetail === void 0 ? void 0 : diagDetail.diagnostic) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.attributes) === null || _d === void 0 ? void 0 : _d.Reference, onClose: () => setShowReference(false) }), (0, jsx_runtime_1.jsx)(DetailPopup_1.default, Object.assign({ placement: 'bottom-start', anchorEl: anchorEl }, { children: (0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ direction: 'column', justifyContent: 'space-between', sx: { height: '75vh' } }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ style: { overflowY: 'auto' } }, { children: !endofModule && ((0, jsx_runtime_1.jsx)(better_react_mathjax_1.MathJax, Object.assign({ inline: true, dynamic: true }, { children: (0, jsx_runtime_1.jsx)("span", { dangerouslySetInnerHTML: { __html: renderImage((_g = (_f = (_e = diagDetail === null || diagDetail === void 0 ? void 0 : diagDetail.diagnostic) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.attributes) === null || _g === void 0 ? void 0 : _g.Directions) } }) }))) })), (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ container: true, justifyContent: 'flex-end', alignItems: 'center' }, { children: (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ color: 'primary', variant: 'contained', sx: { borderRadius: 20, margin: 1 }, onClick: () => setAnchorEl(null) }, { children: "Close" })) })) }))] })) })), (0, jsx_runtime_1.jsx)(Popover_1.default, Object.assign({ open: Boolean(reviewAnchorEl), anchorEl: reviewAnchorEl, onClose: () => setReviewAnchorEl(null), anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center',
                }, transformOrigin: {
                    vertical: -0.5,
                    horizontal: 'center',
                }, PaperProps: {
                    sx: {
                        minWidth: '40vw',
                        minHeight: '40vh',
                        maxWidth: '50vw',
                        marginLeft: 1,
                        marginTop: -5,
                    },
                } }, { children: (0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ sx: { p: 2 } }, { children: (0, jsx_runtime_1.jsx)(Review_1.default, { questions: questions, currtentIndex: currentQuestion, forReview: forReview, answers: answers, header: `Module ${currentDiagnostic + 1}: ${(_k = (_j = (_h = diagDetail === null || diagDetail === void 0 ? void 0 : diagDetail.diagnostic) === null || _h === void 0 ? void 0 : _h.data) === null || _j === void 0 ? void 0 : _j.attributes) === null || _k === void 0 ? void 0 : _k.Name}`, closeReview: () => setReviewAnchorEl(null), setReviewQuestion: setReviewQuestion, setReviewpage: setReviewPage }) })) })), (0, jsx_runtime_1.jsx)(Confirmation_1.default, { open: openConfirm, confirmAnswer: confirmAnswer, isLast: !endModule, modulename: (_o = (_m = (_l = diagDetail === null || diagDetail === void 0 ? void 0 : diagDetail.diagnostic) === null || _l === void 0 ? void 0 : _l.data) === null || _m === void 0 ? void 0 : _m.attributes) === null || _o === void 0 ? void 0 : _o.Name }), (0, jsx_runtime_1.jsx)(AppBar_1.default, Object.assign({ color: 'default' }, { children: (0, jsx_runtime_1.jsx)(Toolbar_1.default, { children: (0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ container: true, spacing: { xs: 2, md: 3 }, columns: { xs: 4, sm: 8, md: 12 } }, { children: [(0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ item: true, xs: 2, sm: 4, md: 4 }, { children: [(0, jsx_runtime_1.jsxs)(Typography_1.default, Object.assign({ variant: 'h6', component: 'div', sx: { flexGrow: 1 } }, { children: ["Module ", currentDiagnostic + 1, ": ", (_r = (_q = (_p = diagDetail === null || diagDetail === void 0 ? void 0 : diagDetail.diagnostic) === null || _p === void 0 ? void 0 : _p.data) === null || _q === void 0 ? void 0 : _q.attributes) === null || _r === void 0 ? void 0 : _r.Name] })), (0, jsx_runtime_1.jsx)(ClickAwayListener_1.default, Object.assign({ onClickAway: handleClickAway }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ size: 'medium', color: 'inherit', onClick: handleClick, sx: { textTransform: 'unset' }, endIcon: (0, jsx_runtime_1.jsx)(KeyboardArrowUp_1.default, {}) }, { children: "Directions" })) }))] })), (0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ item: true, xs: 2, sm: 4, md: 4, style: { textAlign: 'center', display: 'flex', justifyContent: 'center' } }, { children: [showTimer ? ((0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ item: true, xs: 2, sm: 4, md: 4, style: { textAlign: 'center' } }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: 'h6', component: 'div', sx: { padding: '4px 0' } }, { children: timer != 0 && ((0, jsx_runtime_1.jsx)(react_countdown_1.default, { date: startDate.current + timer * 1000, renderer: defaultRenderer })) })), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ size: 'medium', color: 'inherit', variant: 'outlined', sx: { textTransform: 'unset', borderRadius: 20, height: 25, padding: '4px 0' }, onClick: () => {
                                                    setShowTimer(false);
                                                } }, { children: "Hide" }))] }))) : ((0, jsx_runtime_1.jsx)("i", { className: 'fa fa-clock-o', style: { fontSize: 35, cursor: 'pointer', padding: '10px 20px' }, onClick: () => {
                                            setShowTimer(true);
                                        } })), !negativeTime ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})) : ((0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ item: true, xs: 2, sm: 4, md: 4, style: { textAlign: 'center' } }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: 'h6', component: 'div', sx: { padding: '4px 0', color: 'red' } }, { children: (0, jsx_runtime_1.jsx)(react_countdown_1.default, { date: negstartDate.current, renderer: negdefaultRenderer, overtime: true }) })), (0, jsx_runtime_1.jsx)(Typography_1.default, { children: "Overtime" })] })))] })), (0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ item: true, xs: 2, sm: 4, md: 4, sx: { textAlign: 'right', display: 'inline-flex', justifyContent: 'right' } }, { children: [((_u = (_t = (_s = diagDetail === null || diagDetail === void 0 ? void 0 : diagDetail.diagnostic) === null || _s === void 0 ? void 0 : _s.data) === null || _t === void 0 ? void 0 : _t.attributes) === null || _u === void 0 ? void 0 : _u.CalcEnabled) && ((0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ color: 'inherit', onClick: () => setShowCalculator(!showCalculator), sx: {
                                            display: 'grid',
                                            textTransform: 'inherit',
                                            marginLeft: 'auto',
                                        } }, { children: [(0, jsx_runtime_1.jsx)("i", { className: 'fa fa-calculator fa-lg' }), "Calculator"] }))), ((_x = (_w = (_v = diagDetail === null || diagDetail === void 0 ? void 0 : diagDetail.diagnostic) === null || _v === void 0 ? void 0 : _v.data) === null || _w === void 0 ? void 0 : _w.attributes) === null || _x === void 0 ? void 0 : _x.Reference) && ((0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ color: 'inherit', onClick: () => setShowReference(!showReference), sx: {
                                            display: 'grid',
                                            textTransform: 'inherit',
                                        } }, { children: [(0, jsx_runtime_1.jsxs)("span", Object.assign({ style: { fontSize: 14, marginTop: '-4px' } }, { children: ["X ", (0, jsx_runtime_1.jsx)("sup", { children: "2" })] })), "Reference"] }))), (0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ color: 'inherit', onClick: () => setSaveExitDialogOpen(true), sx: {
                                            display: 'grid',
                                            textTransform: 'inherit',
                                            justifyContent: 'right'
                                        } }, { children: [(0, jsx_runtime_1.jsx)("i", { className: 'fa fa-save fa-lg' }), "Save and Exit"] }))] }))] })) }) })), (0, jsx_runtime_1.jsx)(Toolbar_1.default, {}), !reviewPage ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: !isLoading ? ((0, jsx_runtime_1.jsx)(Question_1.default, { question: question, review: review, answer: answers.find((i) => i.questionId === question.id), currentQuestion: currentQuestion + 1, setReview: handleMarkReview, setAnswer: handleSelectedAnswer, endofModule: endofModule })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})) })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(Container_1.default, { children: (0, jsx_runtime_1.jsx)(ReviewPage_1.default, { questions: questions, currtentIndex: currentQuestion, forReview: forReview, answers: answers, header: `Module ${currentDiagnostic + 1}: ${(_0 = (_z = (_y = diagDetail === null || diagDetail === void 0 ? void 0 : diagDetail.diagnostic) === null || _y === void 0 ? void 0 : _y.data) === null || _z === void 0 ? void 0 : _z.attributes) === null || _0 === void 0 ? void 0 : _0.Name}`, closeReview: () => setReviewAnchorEl(null), setReviewQuestion: setReviewQuestion, setReviewpage: setReviewPage }) }) })), (0, jsx_runtime_1.jsx)(AppBar_1.default, Object.assign({ color: 'default', position: 'fixed', sx: { top: 'auto', bottom: 0 } }, { children: (0, jsx_runtime_1.jsx)(Toolbar_1.default, { children: (0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ container: true, spacing: { xs: 2, md: 3 }, columns: { xs: 4, sm: 8, md: 12 } }, { children: [(0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 2, sm: 4, md: 4 }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: 'h6', component: 'div', sx: { flexGrow: 1 } }, { children: (user === null || user === void 0 ? void 0 : user.firstName) || '' })) })), (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 2, sm: 4, md: 4, style: { textAlign: 'center' } }, { children: !reviewPage ? ((0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ size: 'medium', variant: 'contained', color: 'inherit', onClick: handleReviewClick, sx: {
                                        textTransform: 'unset',
                                        backgroundColor: 'black',
                                        color: 'white',
                                        '&:hover': {
                                            backgroundColor: 'gray  ',
                                        },
                                    }, endIcon: (0, jsx_runtime_1.jsx)(KeyboardArrowUp_1.default, {}) }, { children: ["Question ", currentQuestion + 1, " of ", questions === null || questions === void 0 ? void 0 : questions.length] }))) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})) })), (0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ item: true, xs: 2, sm: 4, md: 4, sx: { textAlign: 'right', textTransform: 'unset' } }, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onKeyDown: (e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                            }
                                        }, color: 'primary', variant: 'contained', sx: { borderRadius: 20, marginRight: 1 }, disabled: currentQuestion === 0, onClick: () => handleNext(false) }, { children: "Back" })), !reviewPage ? ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onKeyDown: (e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                            }
                                        }, color: 'primary', variant: 'contained', sx: { borderRadius: 20 }, onClick: (questions === null || questions === void 0 ? void 0 : questions.length) === currentQuestion + 1 ? handleReview : () => handleNext(true) }, { children: (questions === null || questions === void 0 ? void 0 : questions.length) === currentQuestion + 1 ? 'Review' : 'Next' }))) : ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onKeyDown: (e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                            }
                                        }, color: 'primary', variant: 'contained', sx: { borderRadius: 20 }, onClick: handleComplete }, { children: "Complete" })))] }))] })) }) })), (0, jsx_runtime_1.jsxs)(material_1.Dialog, Object.assign({ open: saveExitDialogOpen, onClose: saveExithandleClose, "aria-labelledby": "saveandexit-dialog-title", "aria-describedby": "saveandexit-dialog-description" }, { children: [(0, jsx_runtime_1.jsx)(material_1.DialogTitle, Object.assign({ id: "saveandexit-dialog-title" }, { children: "Do you want to save test and comeback later?" })), (0, jsx_runtime_1.jsxs)(material_1.DialogActions, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: () => saveExithandleSave() }, { children: "Yes" })), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: () => saveExithandleClose(), autoFocus: true }, { children: "No" }))] })] }))] }));
}
exports.default = Quiz;
